module.exports = __webpack_public_path__ + "img/avatar.22c7aabb.jpeg";